// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__tuSTS","modalForm":"UpgradeEpcsModal_modalForm__3XrLO","modalFooter":"UpgradeEpcsModal_modalFooter__18oqj"};